var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Link = (props) => {
    const { className } = props, otherProps = __rest(props, ["className"]);
    const classes = [className, 'rds-icon'].filter(Boolean).join(' ');
    return (_jsx("svg", Object.assign({ viewBox: "0 0 24 24" }, otherProps, { className: classes, xmlns: "http://www.w3.org/2000/svg" }, { children: _jsxs("g", { children: [_jsx("path", { d: "M12.354 8.11a3.501 3.501 0 0 1 .566 4.21c-.123.216-.107.493.069.668l.73.73c.207.208.55.194.716-.05a5.502 5.502 0 0 0-8.445-6.97L3.16 9.525a5.5 5.5 0 0 0 5.976 8.98c.307-.126.362-.52.128-.755l-.815-.815a.547.547 0 0 0-.526-.131 3.5 3.5 0 0 1-3.349-5.865l2.829-2.828a3.5 3.5 0 0 1 4.95 0Z" }), _jsx("path", { d: "m16.596 15.889 2.829-2.828a3.5 3.5 0 0 0-2.236-5.967.542.542 0 0 1-.348-.152l-1.01-1.011c-.265-.264-.154-.71.215-.771a5.5 5.5 0 0 1 4.793 9.315l-2.829 2.828a5.5 5.5 0 1 1-7.778-7.778.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .707 3.5 3.5 0 1 0 4.95 4.95Z" })] }) })));
};
